import { connect } from "react-redux";
import { mapStateToProps } from "../store/helpers/mapState";
import { mapDispatchToProps } from "../store/helpers/mapDispatch";
import { Button, Card, CardContent, Chip, CircularProgress, Dialog, DialogContent, IconButton, Typography } from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";
import moment from "moment/moment";
import * as React from "react";
import { useEffect, useRef, useState } from "react";
import { errorToast, successToast } from "../helpers/Notification";
import { getError, getSuccessMessage } from "../store/helpers/common_functions";

const WorklogChat = ({ worklog, inline, FetchDetails, open, SubmitGeneralForm, loggedUser, onClose,onSuccess }) => {
    const [sendingChats, setSendingChats] = useState(false);
    const [loadingChats, setLoadingChats] = useState(false);
    const [chats, setChats] = useState([]);
    const chatRef = useRef(null);

    const loadChats = async () => {
        setLoadingChats(true);
        const resp = await FetchDetails(`/api/worklogs/comments/${worklog?.id}`);
        setLoadingChats(false);
        if (resp.status) {
            setChats(resp.data.data);
        }
    }


    useEffect(() => {
        if (worklog?.id) {
            loadChats().then();
        }
    }, [worklog]);

    const submitChats = async (data) => {
        setSendingChats(true);
        const resp = await SubmitGeneralForm(`/api/worklogs/createChat`, data);
        if (resp.status) {
            chatRef.current?.reset();
            loadChats().then();
            onSuccess().then()
            successToast(getSuccessMessage(resp));
        } else {
            errorToast(getError(resp));
        }
        setSendingChats(false);
    }

    const className = `'border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150`;


    const content = <>
        <div style={{ height: "450px", overflowY: "auto" }} className={'mb-3'}>
            {!chats.length || loadingChats ?
                <div className={'text-center flex items-center justify-center h-full'}>
                    <div>
                        {loadingChats ? <CircularProgress /> : <>
                            <InfoOutlined />
                            <div>Chat content goes here !</div>
                        </>}
                    </div>
                </div> : <div>
                    {chats.map((v) => {
                        const isUserSender = loggedUser.resourceId === v.resource.id
                        return (
                            <div style={{ display: 'flex', width: '100%', justifyContent: isUserSender ? 'end' : 'start' }}>
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: isUserSender ? 'end' : 'start' }}>
                                    <Chip label={
                                        <Typography style={{
                                            whiteSpace: 'normal',
                                            fontSize: "13px"
                                        }}>{v.description}</Typography>
                                    }
                                    />
                                    <div>
                                        <span style={{ fontSize: "11px" }}>
                                            {v.resource.names} at {moment(v.createdAt).format(
                                                moment(v.createdAt).isSame(moment(), 'day') ? "HH:mm" : "yyyy MMM DD"
                                            )}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        )
                    }
                    )}
                </div>}
        </div>
        <form action={""} ref={chatRef} onSubmit={e => {
            e.preventDefault();
            const data = new FormData(e.currentTarget);
            submitChats({
                worklogId: worklog?.id,
                description: data.get("description")
            }).then();
        }} className={'flex'}>
            <div className={'mb-3 flex-grow'}>
                <textarea rows={2} placeholder={"Enter chat details"}
                    className={className} name={'description'} required={true}></textarea>
            </div>
            <div style={{ paddingLeft: "5px" }}>
                {sendingChats ? <CircularProgress /> :
                   <Button
                   sx={{
                        backgroundColor: "#56677d",
                        color: "white",
                        "&:hover": {
                            backgroundColor: "#56677d",
                            color: "white"
                        }
                    
                   }}
                    type={'submit'} variant={'contained'}>Send Now</Button>}
            </div>
        </form>
    </>;

    return <Dialog open={open} onClose={onClose} maxWidth={'md'} fullWidth={true}>
            <div className={"flex items-center p-3 "}>
                                <div className={"flex-grow font-bold text-lg"}>
                                
                                </div>
                                <IconButton onClick={
                                  () => {
                                    onClose();
                                  }
                                }>
                                  <img
                                    src={require("assets/icons/close.svg").default}
                                    alt={"close"}
                                  />
                                </IconButton>
                              </div>
    <DialogContent>

        {content}
    </DialogContent>
</Dialog>
    //   inline ? <Card>
    //       <CardContent>
    //           {content}
    //       </CardContent>
    //   </Card> :
    // <Dialog open={open} onClose={onClose} maxWidth={'md'} fullWidth={true}>
    //     <DialogContent>
    //         {content}
    //     </DialogContent>
    // </Dialog>
}

export default connect(mapStateToProps, mapDispatchToProps)(WorklogChat);